<template>
  <div class="container-fluid">
    <div class="spinner-cover-new" v-if="is_loading">
      <div class="spinner"></div>
    </div>
    <!-- NAV ON TASKS TODO: FIX ALIGNMENT -->
    <div class="button-areas">
      <div class="row border-bottom pt-2 pb-2">
        <div class="col-xl-3 col-lg-2 col-md-2 pl-1">

          <button  type="button" v-if="sideBar" @click="$parent.sideBar = false" class="btn btn-light filter-btn filter-icon-sidebar ml-1" style="background: dodgerblue;color: white !important;">
            <img class="plus-img" src="@/assets/images/img-icons/filter2_white.svg" alt="img">
            <img class="plus-img white" src="@/assets/images/img-icons/filter2_white.svg" alt="image">
          <span class="icons-text-top-bar"> Filter</span>
          </button>

          <button type="button" v-else  @click="$parent.sideBar = true"   class="btn btn-light filter-btn filter-icon-sidebar ml-1">
            <img class="plus-img"  src="@/assets/images/img-icons/filter2_black.svg" alt="img" >
            <img class="plus-img white" src="@/assets/images/img-icons/filter2_white.svg" alt="image">
           <span class="icons-text-top-bar">Filter</span>
          </button>

<!--          <button type="button" class="btn btn-light ml-2 visibility-hidden" @click="$router.push({ name: 'photoDocumentation' })">-->
<!--            {{$t('documentation')}}-->
<!--          </button>-->
<!--          <button type="button" class="btn btn-light ml-2 active visibility-hidden simple-photo-check">-->
<!--            {{$t('construction_diaries')}}-->
<!--          </button>-->
        </div>



        <!--         Date Range Slider Start Here-->
<!--        <div class="col-lg-6 col-md-6 col-sm-12 photo-top-midle pr-0 pl-1">-->
<!--          <div class="date-container w-100">-->
<!--          <div class="row m-0">-->
<!--            <div class="col-md-3 p-0 pr-2">-->
<!--              <div class="d-flex date date-pick datepicker float-right datepicker mr-1" data-date-format="dd.mm.yyyy">-->
<!--                <span class="input-group-addon this-calender mr-1 font1rem">-->
<!--                  <i class="fa-regular fa-calendar-minus"></i></span>-->
<!--                <input id="minDate"-->
<!--                       data-date-format="dd.mm.yyyy"-->
<!--                       class="form-control date-input"-->
<!--                       v-model="dateRangeFrom" type="text" readonly="">-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="col-md-6 p-0">-->
<!--              <div class="filter level-filter w-100 level-req">-->
<!--                <input type="text" class="js-range-slider" id="rangeSliderInTasksDocs" name="my_range" value="" />-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="col-md-3 p-0">-->
<!--              <div class="d-flex date date-pick datepicker ml-1" data-date-format="dd.mm.yyyy">-->
<!--                <input id="maxDate"-->
<!--                       data-date-format="dd.mm.yyyy"-->
<!--                       class="form-control date-input ml-1"-->
<!--                       v-model="dateRangeTo"  type="text" readonly="">-->
<!--                <span class="input-group-addon this-calender ml-1 font1rem">-->
<!--               <i class="fa-regular fa-calendar-minus"></i>-->
<!--            </span>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          </div>-->
<!--        </div>-->
        <!--         Date Range Slider Ends Here-->


        <div class="col photo-top-midle">
          <div id="datepicker_f" class="d-flex input-group this-calender input-group-sm date mr-2 ml-auto datepicker_small_input" data-date-format="dd.mm.yyyy">
            <div class="input-group-prepend">
              <span class="input-group-text" ><i class="fa-regular fa-calendar-minus"></i></span>
            </div>
            <input id="datepicker_from"
                   type="text"
                   class="form-control date-input"
                   data-date-format="dd.mm.yyyy"
                   v-model="dateRangeFrom"
                   :disabled="!dateRangeFrom"
                   readonly="">
          </div>

          <div class="filter level-filter level-req">
            <input type="text" class="js-range-slider" id="rangeSliderInTasksDocs" name="my_range" value="" />
          </div>

          <div id="datepicker_t" class="d-flex input-group this-calender input-group-sm date ml-2 mr-auto datepicker_small_input" data-date-format="dd.mm.yyyy">
            <input id="datepicker_to"
                   type="text"
                   class="form-control date-input"
                   data-date-format="dd.mm.yyyy"
                   :disabled="!dateRangeTo"
                   v-model="dateRangeTo"
                   readonly="" style="margin-top: 0">
            <div class="input-group-append">
              <span class="input-group-text" ><i class="fa-regular fa-calendar-minus"></i></span>
            </div>
          </div>
        </div>




<!--        <div class="right-btn col-md-3 col-sm-3 text-right d-none d-sm-block pl-0 pr-lg-0 pr-xl-0 pr-1">-->
        <div  class="right-btn action-btns col-xl-3 col-lg-3 col-md-3  text-right d-none  d-sm-block p-0">
          <img v-show="dateRangeTo" src="@/assets/images/img-icons/exel-icon.png" @click="exportExelList" width="25" alt="exel" class="shadow exel-icon mr-2">
<!--          <button @click="detailsPage = isEdit = false" :class="{active: !detailsPage}" type="button" class="btn btn-light mb-lg-1 mb-xl-0">-->
<!--            {{ $t('overview') }}-->
<!--          </button>-->
<!--          <button @click="detailsPage = true; isEdit = false" :class="{active: detailsPage}"  type="button" class="btn btn-light mb-lg-1 mb-xl-0">-->
<!--            {{ $t("preview") }}-->
<!--          </button>-->
          <button v-show="dateRangeTo"  type="button" class="btn btn-light mr-2 ml-2"
                   :class="{active: isEdit}"
                   @click="isEdit = !isEdit; detailsPage = !isEdit"
                   cv-visiblemyclass="selectedTask.pdflawid"
                   :disabled="editIsDisabled">
            <i class="fa-regular fa-pen-to-square font14" style="font-size: 0.8rem"></i>
            <span class="icons-text-top-bar">{{ $t("edit") }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import moment from 'moment'
import axios from '../../utils/axiosinstance'
// import axios from 'axios'
export default {
  props: ['meta','sideBar' ,'selectedTask','range'],
  name: 'TopBar',
  data () {
    return {
      searchString: '',
      maintenance: true
    }
  },
  components: {
    // HistogramSlider
  },
  mounted () {
    this.setDatePickers();
  },
  computed: {
    ...mapState({
      is_loading: state => state.constructionDiary.is_loading,
    }),

    dateRangeFrom: {
      get () {
        return  this.$store.state.tasks.tasksMetaDateFrom
      },
      set(val){
        this.$store.commit('setTasksMetaDateFrom',val)
      }
    },

    dateRangeTo: {
      get () {
        return  this.$store.state.tasks.tasksMetaDateTo
      },
      set(val){
        this.$store.commit('setTasksMetaDateTo', val)
      }
    },


    dateFrom: {
      get(){
        return  this.$store.state.tasks.dateFrom
      },
      set(val){
        this.$store.commit("setTasksDateFrom", val)
      }
    },

    dateTo: {
      get(){
        return  this.$store.state.tasks.dateTo
      },
      set(val){
        this.$store.commit("setTasksDateTo", val)
      }
    },
    detailsPage: {
      get(){
        return this.$store.state.tasks.detailsPage
      },set(val){
      this.$store.commit('toggleTasksDetails',val)
      }
    },
    isEdit: {
      get(){
        return this.$store.state.tasks.isEdit
      },set(val){
        this.$store.commit('setTasksIsEdit',val)
      }
    },
    editIsDisabled: {
      get(){
        if( this.selectedTask.pdflawid == undefined || !this.usercan('editor') ) {
          return true;
        }

        if(!this.usercan('editor')) {
          return false;
        }
        // this.selectedTask.pdflawid != undefined || !usercan('editor')


        return false;
      }


    },
    report_id(){
      return  this.$store.state.constructionDiary.selectedReport.constructionreportid || this.$route.params.reportId || 0;
    }
  },
  methods: {
   async exportExelList(){
     this.$store.commit('loading',true)
     let params = [ this.$route.params.id, 15000, null , null,
       [{
           _explicitType: "com\\projectdocu\\OrderSettingVO",
           fieldname: 'flawdate',
           order : 'DESC',
         },{
         _explicitType: "com\\projectdocu\\OrderSettingVO",
         fieldname: 'pdflowid',
         order : 'DESC',
        }],
     ]
     await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`, {
         methodName:  "getFlawsExportList",
         serviceName: "ProjectdocuService",
         parameters: params,
       },
       {
         headers: {
           apitoken: localStorage.apikey,
           deviceid: localStorage.deviceid,
           accept: 'application/json'
         }
       }).then(res => {
          console.log(res.data.objectType)
          this.downloadExel(res.data.objectType);
          this.$store.commit('loading',false)
     })
    },

    async downloadExel(link){
      this.$store.commit('loading',true)
      let url = `${process.env.VUE_APP_BASE_URL}${link}&token=${localStorage.sessiontoken}`
      await fetch(url, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid
        }
      }).then(response => response.blob())
        .then(response => {
          let reader = new FileReader()
          reader.readAsDataURL(response)
          reader.onload = function () {
            let pdf = reader.result
            let link = document.getElementById('download-link');
            link.href = pdf
            link.download = `${moment(new Date()).format('YYYY-MM-DD')}_Mangelbericht.xlsx`
            link.click();
          }
        });
      this.$store.commit('loading',false)
    },

    setDateRangeSlider(){
      let _this = this
      $(".js-range-slider").ionRangeSlider({
        type: "double",
        min: _this.range[0],
        max: _this.range[1],
        drag_interval: true,
        hide_min_max: true,
        hide_from_to: true,
        onFinish: function (val){
          _this.setDateRanges(val);
          _this.onSliderChangeStep(val);
        },
        onChange: function (val){
          _this.onSliderChangeStep(val);
        }
      });
    },

    async setDatePickers () {
      await this.setDateRangeSlider();
      let my_range = $("#rangeSliderInTasksDocs").data("ionRangeSlider");
      let _this = this
      // $('.datepicker').datepicker({
        $('#datepicker_to, #datepicker_from').datepicker({
        autoclose: true,
        todayHighlight: true
      }).change(function (event){
        let value = event.target.value;
        let from =  moment(_this.meta.minimumDate);
        if (event.target.getAttribute('id') === 'datepicker_from'){
          let dif_from = moment(value , 'DD.MM.YYYY');
          let dif = moment.duration(dif_from.diff(from)).asDays();
          my_range.update({
            from: Math.floor(dif),
          });
        } else {
          let to =  moment(_this.meta.maximumDate);
          let dif_to = moment(value , 'DD.MM.YYYY');
          let difToDate = moment.duration(dif_to.diff(to)).asDays();
          my_range.update({
            to: Math.floor(_this.range[1] + difToDate),
          });
        }
        let d_from = $('#datepicker_from').val();
        let d_to = $('#datepicker_to').val();
        _this.dateFrom = d_from;
        _this.dateTo  = d_to;
        _this.dateRangeFrom = d_from;
        _this.dateRangeTo  = d_to;
      });
    },


    onSliderChange(val){
      this.setDateRanges(val);
    },

    setDateRanges (val) {
      let from = val.from
      let to = val.to
      this.dateFrom = moment(this.meta.minimumDate).add(from,'day').format('DD.MM.YYYY');
      this.dateTo = moment(this.meta.maximumDate).add(to  - this.range[1], 'day').format('DD.MM.YYYY')
    },

    onSliderChangeStep(val){
      const from = val.from;
      const to = val.to;
      this.dateRangeFrom = moment(this.meta.minimumDate).add(from,'day').format('DD.MM.YYYY');
      this.dateRangeTo = moment(this.meta.maximumDate).add(to  - this.range[1], 'day').format('DD.MM.YYYY')
    },


    toggleSideBar (value) {
      this.$store.commit('toggleFilterTab', value)
      this.$store.commit('toggleOverViewTab', false)
    },

    showOverview () {
      this.$store.commit('toggleOverViewTab', false)
    },

  },

  maintenance() {
    alert('Zur Zeit wegen Wartungsarbeiten nicht möglich.')
  },
}
</script>
<style scoped type="text/css">
.active{
  color: white !important;
  background: dodgerblue !important;
}
.slider-horizontal{
  padding: 7px 4px !important;
}
.visibility-hidden{
  visibility: hidden;
}
img.exel-icon {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/tasks/TasksTopBar.vue